import React, { FunctionComponent } from "react";
import { Dialog, TextButton } from "@episerver/ui-framework";
import { useStaticQuery, graphql } from "gatsby";

import "./storybook.scss";

interface SiteUrlQueryType {
    site: {
        siteMetadata: {
            customHostnameUIFStorybook: string;
            customHostnamePNStorybook: string;
        };
    };
}

export const query = graphql`
query {
    site {
        siteMetadata {
            customHostnameUIFStorybook,
            customHostnamePNStorybook
        }
    }
}
`;

interface StorybookProps {
    project: "uif" | "pn";
    story: string;
}

export const Storybook: FunctionComponent<StorybookProps> = ({ project, story }) => {
    const siteUrlQuery = useStaticQuery<SiteUrlQueryType>(query);
    const hostname = project === "uif" ? siteUrlQuery.site.siteMetadata.customHostnameUIFStorybook : siteUrlQuery.site.siteMetadata.customHostnamePNStorybook;
    const [open, setOpen] = React.useState(false);

    const StorybookDialog = (): any => {
        return (
            <Dialog
                className="epi-ds-site-storybook--dialog"
                open={true}
                title="Advanced examples"
                dismissLabel="Cancel"
                confirmLabel="Close"
                enableConfirm={true}
                onInteraction={() => setOpen(false)}
            >
                <div className="epi-ds-site-storybook--iframe-wrapper__responsive">
                    <iframe
                        src={`${hostname}?path=/story/${story}`}
                    ></iframe>
                </div>
            </Dialog>
        );
    };

    return (
        <>
            <TextButton className="epi-ds-site-storybook--open-button" onClick={() => setOpen(true)}>Open Advanced Examples in modal dialog</TextButton>
            {open && <StorybookDialog />}
        </>
    );
};
